module.exports = __webpack_public_path__ + "img/banner-1-m.bd6ca3ac.jpg";